import {useEffect, useState} from 'react';
import {
  AccessTechnologyKey,
  BandwidthDisplayType,
  CmsPageContentIdentifier,
  CmsPageContentType,
  Feature,
} from '@/types/av-check';
import {interpolate} from '@/utils';

const useMaxBandwidthInformation = (
  cmsContent: CmsPageContentType,
  maxBandwidthForAccessTechnology?: Map<AccessTechnologyKey, BandwidthDisplayType>,
  enabledFeatures?:Feature[],
) => {
  const [bandwidthElements, setBandwidthElements] = useState({ content: '', title: '' });

  useEffect(() => {
    if (maxBandwidthForAccessTechnology) {
      // TODO: the toggle can be removed after the CL of DTAG_FTTH and the old snippet can also be deleted.
      const isDtagFtthEnabled = enabledFeatures?.includes(Feature.DTAG_FTTH_CCI) || enabledFeatures?.includes(Feature.DTAG_FTTH_WEBSHOP);
      const bandwidthHeader = cmsContent[CmsPageContentIdentifier.SuccessMessageModalHeader];
      const bandwidthContent = isDtagFtthEnabled ? cmsContent[CmsPageContentIdentifier.SuccessMessageModalContentInList]:
      cmsContent[CmsPageContentIdentifier.SuccessMessageModalContent];
      const coaxText = isDtagFtthEnabled? cmsContent[CmsPageContentIdentifier.MaxBandwidthCoaxInList]:cmsContent[CmsPageContentIdentifier.MaxBandwidthCoax];
      const dslText = isDtagFtthEnabled? cmsContent[CmsPageContentIdentifier.MaxBandwidthDslInList]:cmsContent[CmsPageContentIdentifier.MaxBandwidthDsl];
      const homeSpot4GText = isDtagFtthEnabled? cmsContent[CmsPageContentIdentifier.MaxBandwidthHomeSpot4GInList]:cmsContent[CmsPageContentIdentifier.MaxBandwidthHomeSpot4G];
      const homeSpot5GText = isDtagFtthEnabled? cmsContent[CmsPageContentIdentifier.MaxBandwidthHomeSpot5GInList]:cmsContent[CmsPageContentIdentifier.MaxBandwidthHomeSpot5G];
      const ftthText = isDtagFtthEnabled? cmsContent[CmsPageContentIdentifier.MaxBandwidthFtthInList]:cmsContent[CmsPageContentIdentifier.MaxBandwidthFtth];


      const assembledMaxBandwidthText = Array.from(maxBandwidthForAccessTechnology)
        .reduce((text, entry, index) => {
          let tempText = text;

          if (index > 0) {
            tempText = `${tempText}`;
          }
          switch (entry[0]) {
            case AccessTechnologyKey.COAX:
              return coaxText != null ? `${tempText} ${interpolate(coaxText, { maxBandwidth: entry[1].text })}` : tempText;
            case AccessTechnologyKey.DSL:
              return dslText != null ? `${tempText} ${interpolate(dslText, { maxBandwidth: entry[1].text })}` : tempText;
            case AccessTechnologyKey.FMS_4G:
              return homeSpot4GText != null ? `${tempText} ${interpolate(homeSpot4GText, { maxBandwidth: entry[1].text })}` : tempText;
            case AccessTechnologyKey.FMS_5G:
              return homeSpot5GText != null ? `${tempText} ${interpolate(homeSpot5GText, { maxBandwidth: entry[1].text })}` : tempText;
            case AccessTechnologyKey.FTTH:
              return ftthText != null ? `${tempText} ${interpolate(ftthText, { maxBandwidth: entry[1].text })}` : tempText;
            default:
              return tempText;
          }
        }, '');
      const bandwidthContentText = bandwidthContent != null ? interpolate(bandwidthContent, { assembledMaxBandwidthText }) : '';
      setBandwidthElements({ content: bandwidthContentText, title: bandwidthHeader });
    }
  }, [maxBandwidthForAccessTechnology, cmsContent]);

  return bandwidthElements;
};

export default useMaxBandwidthInformation;
